import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import { router } from './router'
import { useAuthStore } from './stores/auth'
import { initTheme } from './composables/useTheme'
import { initAnalytics } from './services/analytics'
import '@fontsource-variable/geist'
import '@fontsource-variable/geist-mono'
import './assets/styles/main.css'

// Resolve the colour theme before anything renders.
initTheme()

const app = createApp(App)

app.directive('observe', {
  mounted(element, binding) {
    if (typeof binding.value === 'function') {
      binding.value(element, binding.instance?.$el ?? null)
    }
  },
})

const pinia = createPinia()
app.use(pinia)

// Resolve the persisted session before the router guards the initial route.
await useAuthStore(pinia).initAuth()
initAnalytics()

app.use(router)
await router.isReady()

app.mount('#app')
